import { createSelector } from "reselect";

export const tanksSelector = createSelector(state => {
    const units = state.unitsReducer.units
    const tanks = state.tanks2.tanks
    const tanksUnitsName = tanks.map(tank => {
        return {
            ...tank,
            numberLabel: units[tank.id_unit]?.number,
            idStation: units[tank.id_unit]?.idStation,
        }
    })
    return tanksUnitsName
}, tanks => tanks)